// extracted by mini-css-extract-plugin
export default {"container":"Yn03G9WuKI4IAZDbTRd2","photo":"mIJZspEiaEf3MvYxoUhl","bgPhoto":"tg8RurlsccM1k29dFP8M","wrapper":"HgPpnjojWNgipkUHN4J7","text":"DWilUoSGVwU3bUgxVNb0"};